export default __webpack_public_path__ + "static/UX-Focused-Development-5e09d36bcc0110ee21d51f94c23c4086.webp";